export default {
  name: 'BusinessSwitch',
  path: '/business_switch',
  component: () =>
    import(/* webpackChunkName: "business_switch" */ './index.vue')
}
